const CheckIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.45019 12.946C2.823 11.3189 2.823 8.68066 4.45018 7.05348L7.74601 3.75765C9.37319 2.13047 12.0114 2.13047 13.6386 3.75765L16.9344 7.05347C18.5616 8.68066 18.5616 11.3188 16.9344 12.946L13.6386 16.2419C12.0114 17.869 9.3732 17.869 7.74601 16.2419L4.45019 12.946Z"
        stroke="#6059FF"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7858 8.92236L10.1689 11.5393L8.5957 9.97113"
        stroke="#6059FF"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
